import { Box, Grid, HStack, VStack } from "@chakra-ui/react";
import "./index.css";
import { UserProvider } from "./provider";
import Name from "./_name";
import Image from "./_image";
import FollowButton from "./_followBtn";
import ConnectButton from "./_connectBtn";
import OptionsButton from "./_optionsBtn";
import ShareButton from "./_shareButton";
import Stats from "./_stats";
import Bio from "./_bio";

/**
 * @param {import("./props").UserProps} props
 */
export default function DetailedUser(props) {
  return (
    <UserProvider user={props} w="full" minW='0'>
      <Grid
        gridTemplateColumns="100px 1fr"
        gridTemplateRows="repeat(2, 1fr)"
        h="100px"
        columnGap="5"
        w="full"
      >
        <Image gridArea="1 / 1 / 3 / 2" />
        <HStack
          gridArea="1 / 2 / 2 / 3"
          justify={"space-between"}
          align={"flex-start"}
          w="full"
        >
          <VStack spacing="0.5" align="flex-start" justify="center">
            <Name variant="fullName" fontSize={"xl"} fontWeight={"semibold"} />
            <Name variant="username" />
          </VStack>
          {!props.allowEdit ? (
            <HStack>
              <HStack spacing={0} bg="#2d2d2d" borderRadius={"full"}>
                <FollowButton />
                <ConnectButton />
              </HStack>
              <OptionsButton />
            </HStack>
          ) : (
            <ShareButton />
          )}
        </HStack>
        <VStack justify={"center"} gridArea={"2 / 2 / 3 / 3"} w="full" minW="0">
          <Bio />
        </VStack>
      </Grid>
    </UserProvider>
  );
}
